(function() {
  var answers = {};
  var history = ['open'];
  var current = 'open';
  var allCards = [
    'open','q1','q2','q3','q4','q5','q6','q7','q8','q9','q10',
    'q11','q12','q13','q14','q15','q16','q17','q19','q20',
    'q23','q24','q25','q26','q27','q28','q29','q30','q31','end'
  ];
  var totalQ = allCards.length - 2;

  var SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbz1A3t9Fh9ibUH8EXdXPTBoFEyf0eXnlVmMQHcHvK217UpCgIg2bKZpZVIoA2Ck7k24vQ/exec';

  var npsWrap = document.getElementById('bs-nps-q1');
  if (!npsWrap) return; // only run on survey page
  for (var i = 0; i <= 10; i++) {
    (function(val) {
      var btn = document.createElement('button');
      btn.className = 'bs-nps-btn';
      btn.textContent = val;
      btn.onclick = function() {
        document.querySelectorAll('.bs-nps-btn').forEach(function(b){ b.classList.remove('selected'); });
        btn.classList.add('selected');
        answers['q1'] = String(val);
        hideErr('q1');
      };
      npsWrap.appendChild(btn);
    })(i);
  }

  function showCard(id) {
    document.querySelectorAll('.bs-card').forEach(function(c){ c.classList.remove('active'); });
    document.getElementById('bs-card-' + id).classList.add('active');
    current = id;
    updateProgress(id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function updateProgress(id) {
    var wrap = document.getElementById('bs-progress-wrap');
    if (id === 'open' || id === 'end') { wrap.style.display = 'none'; return; }
    wrap.style.display = 'block';
    var idx = allCards.indexOf(id) - 1;
    var pct = Math.round((idx / totalQ) * 100);
    document.getElementById('bs-progress-bar-fill').style.width = pct + '%';
    document.getElementById('bs-progress-label').textContent = idx + ' of ' + totalQ;
  }

  function hideErr(q) { var el = document.getElementById('bs-err-' + q); if (el) el.style.display = 'none'; }
  function showErr(q) { var el = document.getElementById('bs-err-' + q); if (el) el.style.display = 'block'; }

  window.bsSelect = function(btn, q, multi) {
    if (!multi) {
      document.querySelectorAll('[data-q="' + q + '"]').forEach(function(b){ b.classList.remove('selected'); });
      btn.classList.toggle('selected');
      answers[q] = btn.classList.contains('selected') ? btn.textContent.trim() : '';
    } else {
      btn.classList.toggle('selected');
      var sel = [];
      document.querySelectorAll('[data-q="' + q + '"].selected').forEach(function(b){ sel.push(b.textContent.trim()); });
      answers[q] = sel.join(', ');
    }
    hideErr(q);
  };

  function validate(q) {
    var textInputs = ['q9','q17','q20','q24','q25','q26','q27','q28'];
    if (textInputs.indexOf(q) > -1) {
      var val = document.getElementById('bs-input-' + q).value.trim();
      answers[q] = val;
      if (!val) { showErr(q); return false; }
      return true;
    }
    if (q === 'q31') {
      var email = document.getElementById('bs-input-q31').value.trim();
      answers['q31'] = email;
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showErr(q); return false; }
      return true;
    }
    if (!answers[q] || answers[q] === '') { showErr(q); return false; }
    return true;
  }

  window.bsGo = function(id) { history.push(id); showCard(id); };

  window.bsNext = function(q, next) {
    if (!validate(q)) return;
    history.push(next);
    showCard(next);
  };

  window.bsNextBranch = function(q, map, fallback) {
    if (!validate(q)) return;
    var ans = answers[q];
    var dest = map[ans] || fallback;
    history.push(dest);
    showCard(dest);
  };

  window.bsBack = function() {
    if (history.length <= 1) return;
    history.pop();
    showCard(history[history.length - 1]);
  };

  window.bsSubmit = function() {
    if (!validate('q31')) return;
    var payload = Object.assign({ submitted_at: new Date().toISOString() }, answers);
    history.push('end');
    showCard('end');
    fetch(SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(function(e){ console.warn('Survey submit error:', e); });
  };

  showCard('open');
})();
